import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-base-currencies',
  templateUrl: './base-currencies.component.html',
  styleUrls: ['./base-currencies.component.css']
})
export class BaseCurrenciesComponent implements OnInit {
    public itemsListBaseCurrencies: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadBaseCurrencies(): Promise<void> {
        this.itemsListBaseCurrencies = await this.datatask.Post(1017);
    }

    private async init() {
        this.loadBaseCurrencies();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('baseCurrencies', {
//        templateUrl: 'views/components/views/baseCurrencies/baseCurrencies.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['baseCurrenciesService', function (baseCurrenciesService) {
//            const vm = this;

//            vm.model = {
//                itemsListBaseCurrencies: []
//            };

//            async function loadBaseCurrencies() {
//                vm.model.itemsListBaseCurrencies = await baseCurrenciesService.listBaseCurrencies();
//            }

//            vm.$onInit = function () {
//                loadBaseCurrencies();
//            }
//        }]
//    });
//})();
